"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleEscrowMock__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  inputs: [],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  inputs: [],
  name: "CallerNotBeneficiary",
  type: "error"
}, {
  inputs: [],
  name: "CallerNotHolder",
  type: "error"
}, {
  inputs: [],
  name: "EmptyReceivingData",
  type: "error"
}, {
  inputs: [],
  name: "InactiveTitleEscrow",
  type: "error"
}, {
  inputs: [],
  name: "InvalidNominee",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "registry",
    type: "address"
  }],
  name: "InvalidRegistry",
  type: "error"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "InvalidTokenId",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    internalType: "address",
    name: "holder",
    type: "address"
  }],
  name: "InvalidTokenTransferToZeroAddressOwners",
  type: "error"
}, {
  inputs: [],
  name: "InvalidTransferToZeroAddress",
  type: "error"
}, {
  inputs: [],
  name: "NomineeAlreadyNominated",
  type: "error"
}, {
  inputs: [],
  name: "RecipientAlreadyHolder",
  type: "error"
}, {
  inputs: [],
  name: "RegistryContractPaused",
  type: "error"
}, {
  inputs: [],
  name: "TargetNomineeAlreadyBeneficiary",
  type: "error"
}, {
  inputs: [],
  name: "TitleEscrowNotHoldingToken",
  type: "error"
}, {
  inputs: [],
  name: "TokenNotSurrendered",
  type: "error"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromBeneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toBeneficiary",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "BeneficiaryTransfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromHolder",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toHolder",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "HolderTransfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "prevNominee",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "nominee",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Nomination",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Shred",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "surrenderer",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Surrender",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "holder",
    type: "address"
  }, {
    indexed: true,
    internalType: "bool",
    name: "isMinting",
    type: "bool"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "TokenReceived",
  type: "event"
}, {
  inputs: [],
  name: "active",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "beneficiary",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "holder",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_registry",
    type: "address"
  }, {
    internalType: "uint256",
    name: "_tokenId",
    type: "uint256"
  }],
  name: "initialize",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_registry",
    type: "address"
  }, {
    internalType: "uint256",
    name: "_tokenId",
    type: "uint256"
  }, {
    internalType: "address",
    name: "_beneficiary",
    type: "address"
  }, {
    internalType: "address",
    name: "_holder",
    type: "address"
  }, {
    internalType: "address",
    name: "_nominee",
    type: "address"
  }],
  name: "initializeMock",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "isHoldingToken",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_nominee",
    type: "address"
  }],
  name: "nominate",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "nominee",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "uint256",
    name: "_tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "onERC721Received",
  outputs: [{
    internalType: "bytes4",
    name: "",
    type: "bytes4"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "registry",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bool",
    name: "val",
    type: "bool"
  }],
  name: "setActive",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "shred",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "surrender",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "tokenId",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_nominee",
    type: "address"
  }],
  name: "transferBeneficiary",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newHolder",
    type: "address"
  }],
  name: "transferHolder",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_nominee",
    type: "address"
  }, {
    internalType: "address",
    name: "newHolder",
    type: "address"
  }],
  name: "transferOwners",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode = "0x60806040523480156200001157600080fd5b50600054610100900460ff166200002f5760005460ff161562000039565b62000039620000de565b620000a15760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b606482015260840160405180910390fd5b600054610100900460ff16158015620000c4576000805461ffff19166101011790555b8015620000d7576000805461ff00191690555b506200010b565b6000620000f630620000fc60201b62000efd1760201c565b15905090565b6001600160a01b03163b151590565b611445806200011b6000396000f3fe608060405234801561001057600080fd5b50600436106101165760003560e01c80637b103999116100a2578063c9437e5e11610071578063c9437e5e146102df578063cd6dc687146102e7578063e534155d146102fa578063f35ba2411461030d578063fd4c9b961461032057600080fd5b80637b1039991461027f578063acec338a14610298578063b332180b146102c4578063b71c47a2146102d757600080fd5b806317d70f7c116100e957806317d70f7c146101a857806320f99c0a146101bf578063299e11d8146101ea57806338af3eed146102645780634302885d1461027757600080fd5b806301ffc9a71461011b57806302fb0c5e1461015357806314bbe21c14610167578063150b7a021461017c575b600080fd5b61013e6101293660046111d8565b6001600160e01b031916623ceffb60e51b1490565b60405190151581526020015b60405180910390f35b60045461013e90600160a01b900460ff1681565b61017a610175366004611221565b610333565b005b61018f61018a36600461123e565b6104d2565b6040516001600160e01b0319909116815260200161014a565b6101b160015481565b60405190815260200161014a565b6004546101d2906001600160a01b031681565b6040516001600160a01b03909116815260200161014a565b61017a6101f83660046112dd565b600080546001600160a01b03968716620100000262010000600160b01b0319909116179055600193909355600280549285166001600160a01b03199384161790556003805491851691909216179055600480546001600160a81b0319169190921617600160a01b179055565b6002546101d2906001600160a01b031681565b61017a610754565b6000546101d2906201000090046001600160a01b031681565b61017a6102a6366004611353565b60048054911515600160a01b0260ff60a01b19909216919091179055565b61017a6102d2366004611221565b6108f2565b61017a610a7b565b61013e610c9a565b61017a6102f5366004611370565b610ca9565b6003546101d2906001600160a01b031681565b61017a61031b36600461139c565b610d6e565b61017a61032e366004611221565b610d7c565b60008060029054906101000a90046001600160a01b03166001600160a01b0316635c975abb6040518163ffffffff1660e01b815260040160206040518083038186803b15801561038257600080fd5b505afa158015610396573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906103ba91906113d5565b905080156103db57604051632b52604760e21b815260040160405180910390fd5b600454600160a01b900460ff1661040557604051637c339b1960e01b815260040160405180910390fd5b6003546001600160a01b031633146104305760405163667b3fbf60e01b815260040160405180910390fd5b610438610f0c565b61045557604051632fd3952360e01b815260040160405180910390fd5b6001600160a01b03821661047c5760405163163ae22d60e11b815260040160405180910390fd5b6003546002546001600160a01b03908116911614806104a857506004546001600160a01b038381169116145b6104c557604051631c98cac360e01b815260040160405180910390fd5b6104ce82610fa8565b5050565b600080600060029054906101000a90046001600160a01b03166001600160a01b0316635c975abb6040518163ffffffff1660e01b815260040160206040518083038186803b15801561052357600080fd5b505afa158015610537573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061055b91906113d5565b9050801561057c57604051632b52604760e21b815260040160405180910390fd5b600454600160a01b900460ff166105a657604051637c339b1960e01b815260040160405180910390fd5b60015485146105d05760405163ed15e6cf60e01b8152600481018690526024015b60405180910390fd5b6000546201000090046001600160a01b031633146106035760405163540b960160e01b81523360048201526024016105c7565b6002546000906001600160a01b0316158061062757506003546001600160a01b0316155b156106c5578361064a576040516310daa94f60e01b815260040160405180910390fd5b6000806106598688018861139c565b90925090506001600160a01b038216158061067b57506001600160a01b038116155b156106ac5760405163bd805e9160e01b81526001600160a01b038084166004830152821660248201526044016105c7565b6106b582610fa8565b6106be81611030565b6001925050505b600354600254600054600154604080516001600160a01b03620100009094048416815260208101929092528515159483169392909216917feac1fdedeedd55f76e4c4a4b9a1b485e1f324cccf90f5aac11af3eb172876049910160405180910390a4507f150b7a023d4804d13e8c85fb27262cb750cf6ba9f9dd3bb30d90f482ceeb4b1f979650505050505050565b60008060029054906101000a90046001600160a01b03166001600160a01b0316635c975abb6040518163ffffffff1660e01b815260040160206040518083038186803b1580156107a357600080fd5b505afa1580156107b7573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906107db91906113d5565b905080156107fc57604051632b52604760e21b815260040160405180910390fd5b600454600160a01b900460ff1661082657604051637c339b1960e01b815260040160405180910390fd5b61082e610f0c565b1561084c57604051631ed483eb60e01b815260040160405180910390fd5b6000546201000090046001600160a01b0316331461087f5760405163540b960160e01b81523360048201526024016105c7565b6108896000610fa8565b6108936000611030565b6004805460ff60a01b1916905560005460015460408051620100009093046001600160a01b0316835260208301919091527fcb63a6e2ad39a5ba99b34f25ee1e8eb1545b98164ae32a05005ef679bdc8801c910160405180910390a150565b60008060029054906101000a90046001600160a01b03166001600160a01b0316635c975abb6040518163ffffffff1660e01b815260040160206040518083038186803b15801561094157600080fd5b505afa158015610955573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061097991906113d5565b9050801561099a57604051632b52604760e21b815260040160405180910390fd5b600454600160a01b900460ff166109c457604051637c339b1960e01b815260040160405180910390fd5b6002546001600160a01b031633146109ef57604051633d48062b60e21b815260040160405180910390fd5b6109f7610f0c565b610a1457604051632fd3952360e01b815260040160405180910390fd5b6002546001600160a01b0383811691161415610a435760405163dd9f921d60e01b815260040160405180910390fd5b6004546001600160a01b0383811691161415610a725760405163131f079d60e31b815260040160405180910390fd5b6104ce826110ae565b60008060029054906101000a90046001600160a01b03166001600160a01b0316635c975abb6040518163ffffffff1660e01b815260040160206040518083038186803b158015610aca57600080fd5b505afa158015610ade573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b0291906113d5565b90508015610b2357604051632b52604760e21b815260040160405180910390fd5b600454600160a01b900460ff16610b4d57604051637c339b1960e01b815260040160405180910390fd5b6002546001600160a01b03163314610b7857604051633d48062b60e21b815260040160405180910390fd5b6003546001600160a01b03163314610ba35760405163667b3fbf60e01b815260040160405180910390fd5b610bab610f0c565b610bc857604051632fd3952360e01b815260040160405180910390fd5b610bd260006110ae565b6000546001546040516323b872dd60e01b8152306004820152620100009092046001600160a01b0316602483018190526044830191909152906323b872dd90606401600060405180830381600087803b158015610c2e57600080fd5b505af1158015610c42573d6000803e3d6000fd5b505060005460015460408051620100009093046001600160a01b0316835260208301919091523393507f33404c8097b8e877f71a3bdea790b1ab1c5dff7b20392e123a875c5c878e3f6e92500160405180910390a250565b6000610ca4610f0c565b905090565b600054610100900460ff16610cc45760005460ff1615610cc8565b303b155b610d2b5760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b60648201526084016105c7565b600054610100900460ff16158015610d4d576000805461ffff19166101011790555b610d57838361112c565b8015610d69576000805461ff00191690555b505050565b610d7782610333565b6104ce815b60008060029054906101000a90046001600160a01b03166001600160a01b0316635c975abb6040518163ffffffff1660e01b815260040160206040518083038186803b158015610dcb57600080fd5b505afa158015610ddf573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610e0391906113d5565b90508015610e2457604051632b52604760e21b815260040160405180910390fd5b600454600160a01b900460ff16610e4e57604051637c339b1960e01b815260040160405180910390fd5b6003546001600160a01b03163314610e795760405163667b3fbf60e01b815260040160405180910390fd5b610e81610f0c565b610e9e57604051632fd3952360e01b815260040160405180910390fd5b6001600160a01b038216610ec55760405163163ae22d60e11b815260040160405180910390fd5b6003546001600160a01b0383811691161415610ef457604051633817373160e11b815260040160405180910390fd5b6104ce82611030565b6001600160a01b03163b151590565b600080546001546040516331a9108f60e11b815230926201000090046001600160a01b031691636352211e91610f49919060040190815260200190565b60206040518083038186803b158015610f6157600080fd5b505afa158015610f75573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f9991906113f2565b6001600160a01b031614905090565b600254600054600154604080516001600160a01b03620100009094048416815260208101929092528483169392909216917f07d0a1a2d5c465ecdf26fb8dda217b10270d8e11ff892df33f73ea690b8cd9b4910160405180910390a361100e60006110ae565b600280546001600160a01b0319166001600160a01b0392909216919091179055565b600354600054600154604080516001600160a01b03620100009094048416815260208101929092528483169392909216917ffebadd5e06bc3e2885248448caca94df39be7cf7fde139b4586ac7b92dfe70b2910160405180910390a3600380546001600160a01b0319166001600160a01b0392909216919091179055565b600454600054600154604080516001600160a01b03620100009094048416815260208101929092528483169392909216917f88a734f529b322845e21a8ea2512c4fd613d73ef43deb62d5c790a1b8037bd21910160405180910390a3600480546001600160a01b0319166001600160a01b0392909216919091179055565b600054610100900460ff166111975760405162461bcd60e51b815260206004820152602b60248201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960448201526a6e697469616c697a696e6760a81b60648201526084016105c7565b600080546001600160a01b03909316620100000262010000600160b01b0319909316929092179091556001556004805460ff60a01b1916600160a01b179055565b6000602082840312156111ea57600080fd5b81356001600160e01b03198116811461120257600080fd5b9392505050565b6001600160a01b038116811461121e57600080fd5b50565b60006020828403121561123357600080fd5b813561120281611209565b60008060008060006080868803121561125657600080fd5b853561126181611209565b9450602086013561127181611209565b935060408601359250606086013567ffffffffffffffff8082111561129557600080fd5b818801915088601f8301126112a957600080fd5b8135818111156112b857600080fd5b8960208285010111156112ca57600080fd5b9699959850939650602001949392505050565b600080600080600060a086880312156112f557600080fd5b853561130081611209565b945060208601359350604086013561131781611209565b9250606086013561132781611209565b9150608086013561133781611209565b809150509295509295909350565b801515811461121e57600080fd5b60006020828403121561136557600080fd5b813561120281611345565b6000806040838503121561138357600080fd5b823561138e81611209565b946020939093013593505050565b600080604083850312156113af57600080fd5b82356113ba81611209565b915060208301356113ca81611209565b809150509250929050565b6000602082840312156113e757600080fd5b815161120281611345565b60006020828403121561140457600080fd5b81516112028161120956fea264697066735822122072d0903f065500f27223cda88193416abc0b325d9104519664e35164ebbaf17164736f6c63430008090033";

const isSuperArgs = xs => xs.length > 1;

class TitleEscrowMock__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(overrides) {
    return super.deploy(overrides || {});
  }

  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.TitleEscrowMock__factory = TitleEscrowMock__factory;

_defineProperty(TitleEscrowMock__factory, "bytecode", _bytecode);

_defineProperty(TitleEscrowMock__factory, "abi", _abi);